export class AveoUniversalApiV1 {
    constructor(socket, log) {
        this.socket = socket;
        this.videoOutputs = Array(33).fill('1');
        this.asyncHandlers = [
            {
                name: 'matrixQuery',
                regExp: /ROUTE\?\s+(\d+)/i,
                callback: (match) => {
                    var _a;
                    const output = parseInt(match[1], 10);
                    const input = (_a = this.videoOutputs[output]) !== null && _a !== void 0 ? _a : '1';
                    this.socket.send(`ROUTE ${input} ${output}`);
                },
            },
            {
                name: 'matrixRoute',
                regExp: /ROUTE\s+(\d+)\s+(\d+)/i,
                callback: (match) => {
                    const output = parseInt(match[2], 10);
                    this.videoOutputs[output] = match[1];
                    this.socket.send(`ROUTE ${match[1]} ${match[2]} OK`);
                },
            },
        ];
    }
}
AveoUniversalApiV1.emulatorType = 'socketEmulator';
AveoUniversalApiV1.key = '-NNsGGfeOj_5Nog4eMf2';
